import { useTheme } from '@/contexts/ThemeContext';
import { useTenantContext } from '@/contexts/TenantContext';

export function useTenantBranding() {
  const { colors } = useTheme();
  const { selectedTenantId } = useTenantContext();
  
  // Check if we're on a subdomain (tenant-branded interface)
  const hostname = window.location.hostname;
  const isSubdomain = hostname !== 'admin.queuemein.com' && hostname.includes('.queuemein.com');
  
  const shouldUseTenantBranding = isSubdomain && selectedTenantId;
  
  return {
    colors,
    shouldUseTenantBranding,
    isSubdomain,
    // Helper functions for applying tenant styles
    getPrimaryButtonClass: () => shouldUseTenantBranding ? 'btn-primary-override' : '',
    getTenantPrimaryClass: () => shouldUseTenantBranding ? 'text-tenant-primary' : '',
    getTenantSecondaryClass: () => shouldUseTenantBranding ? 'text-tenant-secondary' : '',
    getTenantBgPrimaryClass: () => shouldUseTenantBranding ? 'bg-tenant-primary' : '',
    getTenantBgSecondaryClass: () => shouldUseTenantBranding ? 'bg-tenant-secondary' : '',
    getTenantBorderPrimaryClass: () => shouldUseTenantBranding ? 'border-tenant-primary' : '',
  };
}